import { useEffect, useMemo } from 'react';

/**
 * runs effect only once for component
 * @param init method called first time component is rendered
 * @param dispose method called after component unmount
 */
export function useInvariableEffect(init: () => void, dispose?: () => void) {
    useEffect(() => {
        init();

        return dispose;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

/**
 * gets memo only once
 * @param memo method that returns memoed data
 */
export function useInvariableMemo<T>(memo: () => T): T {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(memo, []);
}
